"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALUE_KEYS = void 0;

/**
 * Created by jyothi on 6/6/17.
 */
var VALUE_KEYS = {
  VALUE: "value",
  PERCENT: "percent"
};
exports.VALUE_KEYS = VALUE_KEYS;